module.exports = __webpack_public_path__ + "static/media/slt_card_schedule.b1bf404e.png";